import { combineReducers } from 'redux';
import {security} from './securityReducer'


const appevaweb = combineReducers({
  security
});

export default appevaweb;